<template>
  <div id="app" v-cloak>
    <router-view ></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  provide () {
    return {
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="less">
[v-cloak]{
    display: none;
}
body,html{
  height: 100%;
  width: 100%;
  margin:0;
}
.dialog-open{
  position: fixed;
  width: 100%;
}
@font-face {
    font-family: 'pingfang';
    src: url('./assets/font/PingFang-Medium.ttf'); //你的资源目录
    font-weight: normal;
    font-style: normal;
}
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // color: #2c3e50;
  // background: #f4f4f4;
}
.blue{
  color: #354CB9!important;
}
 

</style>



// WEBPACK FOOTER //
// src/App.vue